import { any, prop } from "ramda";

export const getValueByKey = (objOrArray, key, defaultKey, defaultValue) => {
  let value = defaultValue;
  if (objOrArray?.hasOwnProperty(key)) value = prop(key, objOrArray);
  else if (defaultKey) value = prop(defaultKey, objOrArray);
  return value;
};

export const debounceAsync = (func, wait, immediate) => {
  let timeout;

  return function executedFunction() {
    const context = this;
    const args = arguments;

    return new Promise((resolve, reject) => {
      const later = async function() {
        timeout = null;
        try {
          if (!immediate) {
            const response = await func.apply(context, args);
            resolve(response);
          }
        } catch (err) {
          reject(err);
        }
      };

      const callNow = immediate && !timeout;

      clearTimeout(timeout);

      timeout = setTimeout(later, wait);

      if (callNow)
        func
          .apply(context, args)
          .then(resolve)
          .catch(reject);
    });
  };
};

export function isFunction(functionToCheck) {
  return (
    functionToCheck && {}.toString.call(functionToCheck) === "[object Function]"
  );
}

export const getLastElement = (array = []) => {
  return array.slice(-1)[0];
};

export const selectFilterOption = (input, option) => {
  return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
};

export const selectFilterOptionData = (searchColumns) => (input, option) => {
  return (
    option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
    any(
      (labelKey) =>
        (getValueByKey(option, labelKey) || "")
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0,
      searchColumns
    )
  );
};

export const selectFilterSort = (optionA, optionB) => {
  return (
    optionA?.children
      ?.toString()
      ?.toLowerCase()
      ?.localeCompare(optionB?.children?.toString()?.toLowerCase()) || true
  );
};

export const selectFilterSortData = (optionA, optionB) => {
  return optionA?.label
    ?.toLowerCase()
    ?.localeCompare(optionB?.label?.toLowerCase());
};

export const ellipsize = (text, length) => {
  return text
    ? text.substr(0, length) + (text.length > length ? "..." : "")
    : "";
};

export const generateId = (length, alphaOnly = false) => {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz" +
    (alphaOnly ? "" : "0123456789");
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const formatPhoneWithCountryCode = (cellPhone, countryCode) => {
  if (cellPhone === undefined || cellPhone === null || cellPhone === "") {
    return "";
  }
  return countryCode ? `${countryCode}-${cellPhone}` : `${cellPhone}`;
};

export const formatSecondsToTime = (secs) => {
  if (!secs || isNaN(secs)) return "0s";

  try {
    const secNum = Math.max(0, Math.ceil(secs));
    const hours = Math.floor(secNum / 3600);
    const minutes = Math.floor(secNum / 60) % 60;
    const seconds = secNum % 60;

    return [
      hours > 0 ? `${hours}h` : null,
      minutes > 0 ? `${minutes}m` : null,
      `${seconds}s`,
    ]
      .filter(Boolean)
      .join(" ");
  } catch (error) {
    return "0s";
  }
};
